module.exports = new __parcel__URL__("shop_machines_pirate_nation_golden_galleon.9c589716.png").toString();